// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    name: 'g-login-error',
    computed: {
        errorMessage() {
            //Vars
            let tMessage = this.$route.query.message;
            //Check
            if (!tMessage) {
                return { errorMessage: 'Unknown Error.' };
            }
            return JSON.parse(atob(decodeURI(tMessage)));
        },
    },
    methods: {
        onBack() {
            this.$router.push('/login');
        },
    }
});
// #endregion
